import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../../../../common/state';
import { EMetroTravelType } from '../../../../../../../json_query';
import { changeUndergroundTravelWithSearch } from '../../../../../../state/underground_travel';

import { UndergroundTime as UndergroundTimeComponent } from './undergroundTime';

export const UndergroundTime = connect(
  (state: IAppState) => {
    const travelType =
      (state.filters.jsonQuery.only_foot && state.filters.jsonQuery.only_foot.value) || EMetroTravelType.Any;

    return {
      travelType,
      travelTime: state.filters.jsonQuery.foot_min && state.filters.jsonQuery.foot_min.value.lte,
    };
  },
  (dispatch: Dispatch) => ({
    onUndergroundTravelChange: (travelType: EMetroTravelType, travelTime: number | undefined) => {
      dispatch(changeUndergroundTravelWithSearch(travelType, travelTime));
    },
  }),
)(UndergroundTimeComponent);
